import React, { useState } from 'react'
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Alert,
  FormSelect
} from 'react-bootstrap'


import { useForm } from 'react-hook-form'
import { BASE } from '../../basedata/constants'
import { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'

registerLocale('pt-br', ptBR)

import 'react-datepicker/dist/react-datepicker.css'

import clubLogo from '../../images/club_logo.png'
import bentoLogo from '../../assets/images/logo_sao_bento.png'
import userTest from '../../assets/images/user/jeff_test.jpeg'
import netTest from '../../assets/images/user/neg.jpeg'
import Loader from '../../shared/loader'
import { fetchWithApiKey } from '../../config/apiCall'
import UserBiometryImage from './UserBiometryImage'
import { apiAuth } from './ApiCall'

const maskCPF = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

// (00) 00000-0000
const maskPhone = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})(\d)/, '$1-$2')
}

// 00000-000
const maskCEP = (value: any) => {
  return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
}

// 00/00/0000
const maskDate = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

const isValidEmail = (email: any) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

const strongPassword = (password: any) => {
  return /(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
    password
  )
}

interface Props {
  onResponse: (response: any) => void
}

const SearchTicket = ({ onResponse }: Props) => {

  const auth = sessionStorage.getItem('auth')

  const currentGate = sessionStorage.getItem('gate')

  if (auth !== 'true') {
    window.location.href = '/'
  }

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    getValues,
    reset
  } = useForm()

  const [startDate, setStartDate] = useState(new Date())

  const [hasToken, setHasToken] = useState('')

  const [disableSign, setDisableSign] = useState(false)

  const [userNotFound, setUserNotFound] = useState(false)

  const [motivation, setMotivation] = useState({
    show: false,
    case: 0,
    ticketId: '',
    token: ''
  })

  const [loading, setLoading] = useState(false)
  const [canCleanDocuments, setCanCleanDocuments] = useState(['01875843620', '07018132452'])

  

  const [userData, setUserData] = useState({
  image: '---',
  name: '',
  documentType: '',
  document: '',
  birthday: '',
  transaction: '',
  game: '',
  gameTime: '',
  status: '',
  sector: '',
  gate: '',
  block: '',
  row: '',
  sit: '',
  ticketStatus: '',
  ticketUsed: {
    date: '',
    time: '',
    gate: ''
  },
  ticket: [{
    validTo: '',
    validFrom: '',
    status: '',
    sessionDate: '',
    sessionId: '',
    sessionTime: '',
    gate: '',
    checkInLogs: { createdAt: '', hash: '', sector: '' },
    tokens: [{ type: '', token: '', active: false }] 
  }],
  ingPortao: '',
  supervisor: false
})


  const [searchUser, setSearchUser] = useState('')

  const [newUser, setNewUser] = useState({
    login: '',
    password: '',
    set: false
  })


  const onSubmit = (data: any) => {

    sessionStorage.removeItem('ticket')
    sessionStorage.removeItem('usedTicket')

    setUserNotFound(false)
    setSearchUser('')
    setLoading(true)

    fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.user_validate}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        value: data.document,
        search: data.type,
      })
    })
      .then((res) => res.json())
      .then((response) => {

        setLoading(false)
        
        const hasValidTickets = response.ticket && response.ticket.length > 0
        const hasDocument = response.document
        if (!hasDocument && !hasValidTickets) {
          return setUserNotFound(true)
        }
        
        const firstTicket = response.ticket?.[0]
        const userName = response.name || firstTicket?.holderName || ''
        const userDocument = response.document || firstTicket?.holderDocument || ''
        
        setUserNotFound(false)
        setSearchUser(userDocument)

        const todayDate = new Date();
        const todayDateDay = todayDate.getDate();
        const todayDateMonth = todayDate.getMonth() + 1;

        for(const ticketItem of response.ticket){
          if(ticketItem.status === 'active' &&
            ticketItem.sessionDate ===  `2024-${todayDateMonth}-${todayDateDay}`
          ){
            //sessionStorage.setItem('ticket', ticketItem.tokens[0].token)
          }
        }
        sessionStorage.setItem('token', response.token)
        sessionStorage.setItem('document', userDocument)
        sessionStorage.setItem('gameCode', (response.gameCode || '1111'))
        if (response.ticketStatus === 'valid' || response.ticketStatus === 'discounted') {
          sessionStorage.setItem('usedTicket', 'true')
        }
        
        setUserData({
          ...response,
          name: userName,
          document: userDocument
        })

        if (response.ingPortao !== currentGate) {
          sendWrongGate(response.ticket, currentGate)
        }
      })
      .catch((error) => {
        setUserNotFound(true)
        setLoading(false)
        console.log('- >> ')
        console.log(JSON.stringify(error))
        console.log('- >> | | ')
      })


      fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.user_validate_withsessions}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': BASE.api.api_key
        },
        body: JSON.stringify({
          value: data.document,
          search: data.type,
          sessionType: currentGate
        })
      })
        .then((res) => res.json())
        .then((response) => {
          for(const ticketItem of response.ticket){

          
            if(ticketItem.status === 'active'
            ){
              //sessionStorage.setItem('ticket', ticketItem.tokens[0].token)
            }
          }
        })
        .catch((error) => {
          if(data.refreshAttempts > 1){
            setLoading(false)
            setUserNotFound(true)
            return false
          }
          refreshAndResubimit(data)
        })
  }

  const refreshAndResubimit = async (data: any) => {
    data = {...data, refreshAttempts: 2}
    const refreshToken = sessionStorage.getItem('refreshToken')
  
    let refreshAccess: any = await apiAuth.post(`/auth/refresh-token`,
      {},
      {
        headers: {
          'x-refresh-token': refreshToken,
        }
      }
    )
  
  
    if(refreshAccess.data && refreshAccess.data.refresh_token){
      refreshAccess = refreshAccess.data
      sessionStorage.setItem('user-key', JSON.stringify({user_key: refreshAccess?.token, tenant_id: 'flamengo-zjbgi'}))
      sessionStorage.setItem('refreshToken', refreshAccess?.refresh_token)
    }
  
    onSubmit(data)
  }

  
  const motivationSubmit = (data: any) => {
    sessionStorage.setItem('reason', data.case)


    const reason = data.case
    const ticketNumber = sessionStorage.getItem('ticket')
    const usedTicket = sessionStorage.getItem('usedTicket')
    const blankTicket = sessionStorage.getItem('role')
    const token = sessionStorage.getItem('token')
    const gameCode = sessionStorage.getItem('gameCode')
    const userDocument = sessionStorage.getItem('document')

    // fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.generateLog}`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'x-api-key': BASE.api.api_key
    //   },
    //   body: JSON.stringify({
    //     ticket: ticketNumber,
    //     operator: token,
    //     qrCode: ticketNumber,
    //     imageBase64: '',
    //     reason: reason || 2,
    //     gameCode: gameCode || '00000'
    //   })
    // })

    console.log('URL:', `${BASE.api_user.base_url}${BASE.api_user.biometry_contingency_flag}`)
    console.log('Payload remove_biometric:', { token })

   fetchWithApiKey(
    `${BASE.api_user.base_url}${BASE.api_user.biometry_contingency_flag}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({ token })
    }
  )
    .then(async (res) => {
      const response = await res.json()

      if (!res.ok) {
        console.error('Erro da API:', response)
        throw new Error(response?.message || 'Erro ao remover biometria')
      }

      return response
    })
    .then(() => {
      sessionStorage.removeItem('reason')
      sessionStorage.removeItem('gameCode')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('document')

      window.location.href = `https://ingresse.bepass.com.br/?token=${token}`
    })
    .catch((error) => {
      console.error('Erro na chamada remove_biometric:', error)
      alert('Não foi possível gerar o ingresso')
    })
  }


  const dateFormatter = (dateTime:string)=>{

    const options:any = {
      year: '2-digit',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'UTC'
    };
    
    const oldDate = new Date(dateTime)
    return oldDate.toLocaleDateString('pt-BR', options).split(',').join(' ')
  }

  
  const generateQR = () => {
    const data: any = getValues()
    sessionStorage.setItem('reason', data.case)

    
    const reason = data.case
    const usedTicket = sessionStorage.getItem('usedTicket')
    const blankTicket = sessionStorage.getItem('role')
    const token = sessionStorage.getItem('token')
    const gameCode = sessionStorage.getItem('gameCode')
    const userDocument = sessionStorage.getItem('document')

    onResponse(2)
  }

  const sendWrongGate = (wrongTicket: any, wrongGate: any) => {
    fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.generateAccess}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        "ticket": wrongTicket,
        "gate": wrongGate,
        "deviceIp": "0.0.0.0",
        "registeredFace": "wrongGate",
        'status': 'waiting'
      })
    })
      .catch((error) => {
        console.log(error)
      })
  }
  const resetForm = () => {
    setNewUser({
      login: '',
      password: '',
      set: false
    })
    setHasToken('')
    setDisableSign(false)
    reset()
  }

  if (loading) {
    return (<Loader />)
  }

  if (motivation.show) {
    return (
      <Form onSubmit={handleSubmit(motivationSubmit)}>
        <Table responsive striped >
          <tbody>
            <tr>
              <td>Foto</td>
            </tr>
            <tr>
              <td>
                <UserBiometryImage imagePath={userData.image} imageSide={'face'} />
              </td>
            </tr>
            <tr>
              <td>Qual o motivo da contingência?</td>
            </tr>
            <tr>
              <td className='reason-radios'>

                <Form.Check
                  {...register('case', { required: true })}
                  label="⁠Leitor não reconheceu a face"
                  name="case"
                  type="radio"
                  value="1"
                  id={`1`}
                />
                <Form.Check
                  {...register('case', { required: true })}
                  label="Foto de outra pessoa"
                  name="case"
                  type="radio"
                  value="2"
                  id={`2`}
                />
                {errors.case && (
                  <span className="label-error">
                    Você precisa escolher uma causa
                  </span>
                )}

              </td>
            </tr>
            <tr>
              <td>
                <Button
                  disabled={disableSign}
                  className="mb-0 w-50"
                  variant='outline-primary'
                  onClick={() => generateQR()}
                >
                  Gerar QR
                </Button>

                <Button
                  disabled={disableSign}
                  type="submit"
                  className="mb-0 w-50"
                >
                  Refazer Face
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Form>
    )
  }

  const changeGate = (gate:any) => {
    sessionStorage.setItem('gate', gate)
    return window.location.reload()
  }

  const clearEntrance = async (document:any, host:any) => {
    window.open(`http://${host}:3912/tickets/resetEntrnace/${document}`, '_blank')
      alert('Entrada Resetada')
  }

  const enumGate = (gateNumber:any) =>{

    switch (gateNumber) {
      case 'carneiros_dia':
        return 'Beach Clube';
      case 'carneiros_noite':
          return 'Festa Noturna';
      default:
        return 'N/A';
    }
  }

  return (
    <>

{/* <select className="form-control btn btn-default mb-0 w-100"
          onChange={(event) => {
            const { value } = event.target
            changeGate(value)
          }}>
          <option>Portão Atual {enumGate(currentGate)}</option>
          <option value="carneiros_dia">Beach Clube</option>
          <option value="carneiros_noite">Festa Noturna</option>
      </select> */}
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Card.Title as="h5">
                <span className='club-header'>
                  <img src="https://storage.googleapis.com/companies-assets/ingresse/ingresse_202371623914.png" />
                </span>

                <span className='club-header'>
                  Controle de acesso
                </span>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="mb-3">
                      <Col>
                        <Form.Label>Tipo do documento</Form.Label>
                        <FormSelect
                          className="form-control"

                          onChange={(event) => {
                            const { value } = event.target
                            // setReportType(value)
                          }}
                        >
                          <option value="access">CPF</option>
                          <option value="signup">Outro</option>
                        </FormSelect>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <Form.Label>Número do documento</Form.Label>
                        <Form.Control placeholder="Número do documento" {...register('document')} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group>
                          <Button
                            disabled={disableSign}
                            type="submit"
                            className="mb-0 w-100"
                          >
                            Pesquisar
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>

              {newUser.set && (
                <>
                  <hr />
                  <Row>
                    <Col className="qr-wrapper">
                      <h3>Aprovador cadastrado com sucesso!</h3>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card></Col>
      </Row>
      {userNotFound && <Row>

        <Col>
          <Alert className='text-center' variant='danger'>Não encontrado</Alert>
        </Col>
      </Row>
      }
      {(canCleanDocuments.includes(userData.document)) && (
<>
  
          <Button
              disabled={disableSign}
              type="submit"
              className={`ticket-action yellow`}
              onClick={() => {
                clearEntrance(userData.document, '10.0.8.163')
              }}
            >
              Limpar Acesso Dia
            </Button>
            <Button
              disabled={disableSign}
              type="submit"
              className={`ticket-action purple`}
              onClick={() => {
                clearEntrance(userData.document, '10.0.8.170')
              }}
            >
              Limpar Acesso Noite
            </Button>
            </>
          )}
      {searchUser && <Row>
        <Col>
          <Card>
            <Card.Header>
              <Card.Title as="h5">
                <span className='club-header'>Dados do Ingresso</span>
              </Card.Title>
            </Card.Header>
            <Table responsive striped>
             <tbody>
  {userData.ticket
    ?.filter(t => t.sessionDate && t.sessionTime)
    .sort((a, b) => {
      const cleanDate = (d = '') => d.replaceAll('-', '').replaceAll('/', '');
      const cleanTime = (t = '') => t.replaceAll('-', '').replaceAll(':', '');
      
      const dateA = Number(`${cleanDate(a.sessionDate)}${cleanTime(a.sessionTime)}`);
      const dateB = Number(`${cleanDate(b.sessionDate)}${cleanTime(b.sessionTime)}`);
      
      return dateA - dateB;
    })
    .map(t => (
      <tr key={t.sessionId}>
        <th>Status:</th>
        <td>{t.status}</td>
        <th>Data do ingresso:</th>
        <td>{t.sessionDate} {t.sessionTime}</td>
        <th>Portão:</th>
        <td>{t.gate}</td>
        <th>ID sessão:</th>
        <td>{t.sessionId}</td>
        <th className={t.checkInLogs ? 'checked' : ''}>Check-in:</th>
        <td className={t.checkInLogs ? 'checked' : ''}>
          {t.checkInLogs ? dateFormatter(t.checkInLogs.createdAt) : 'Não Feito'}
        </td>
        <td>
          <Button
            disabled={disableSign}
            type="button"
            className={`ticket-action ${t.checkInLogs ? 'red' : ''}`}
            onClick={() => {
              const token = t.tokens?.[0]?.token;
              if (token) {
                sessionStorage.setItem('ticket', token);
              }
              setMotivation({
                show: true,
                case: 0,
                ticketId: t.sessionId,
                token
              });
            }}
          >
            {t.checkInLogs ? 'Acesso Já utilizado' : 'Gerar Acesso'}
          </Button>
        </td>
      </tr>
    ))}
  
  <tr>
    <td>{userData.gameTime}</td>
  </tr>
  <tr>
    <td>{userData.status}</td>
  </tr>
</tbody>


            </Table>
            {/* <Button
              disabled={disableSign}
              type="submit"
              className={`ticket-action ${(userData.ticketStatus === 'invalid') ? 'red' : (userData.ticketStatus === 'valid') ? '' : 'yellow'}`}

              onClick={() => {

                // if(confirm("Tirar ?")){
                // onResponse(1)
                setMotivation(prev => ({
                  ...prev,
                  show: true,
                  case: 0
                }))
                // }
              }}
            >
              {(userData.ticketStatus === 'invalid') ? 'Acesso Já utilizado' : (userData.ticketStatus === 'valid') ? 'Gerar Acesso' : 'Meia Entrada - Validar Ingresso'}
            </Button> */}


            {userData.ticketStatus === 'invalid' &&
              <Table responsive striped>
                <tbody>
                <tr className='text-center'>
                  <td>Utilização</td>
                </tr>
                <tr>
                  <td className='text-center'>
                    {userData.ticketUsed.date.replace(/T/, ' ').replace(/Z/, ' ')} <br/>
                    Portão {userData.gate}
                  </td>
                </tr>
                </tbody>
              </Table>}

            <Table responsive striped>
              <tbody>
              <tr>
                <td>Foto</td>
              </tr>
              <tr>

                <td>
                  {userData.image && userData.image !== '---' ? (
                    <UserBiometryImage
                      key={userData.image + String(Date.now())}
                      imagePath={userData.image}
                      imageSide={'face'}
                    />
                  ) : (
                    <span>Foto não cadastrada</span>
                  )}
                </td>
              </tr>

              <tr>
                <td>Nome</td>
              </tr>
              <tr>
                <td>{userData.name || 'Não cadastrado'}</td>
              </tr>

              <tr>
                <td>Documento</td>
              </tr>
              <tr>
                <td>{userData.document || 'Não cadastrado'}</td>
              </tr>

              <tr>
                <td>Data de Nascimento</td>
              </tr>
              <tr>
                <td>{userData.birthday || 'Não cadastrado'}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td></td>
              </tr>
              </tfoot>
            </Table>
            {(userData.ingPortao === currentGate && userData.supervisor === false) &&
              <Button
                disabled={disableSign}
                type="submit"
                className={`ticket-action`}

                onClick={() => {
                  setMotivation(prev => ({
                    ...prev,
                    show: true,
                    case: 0
                  }))
                }}
              >
                Gerar Acesso
              </Button>
            }

            {userData.ticketStatus === 'invalid' &&
              <Table responsive striped>
                <tbody>
                <tr className='text-center'>
                  <td>Utilização</td>
                </tr>
                <tr>
                  <td className='text-center'>
                    {userData.ticketUsed.date} - {userData.ticketUsed.time} <br/>
                    Portão {userData.ticketUsed.gate}
                  </td>
                </tr>
                </tbody>
              </Table>}
            <Card.Body>

              <Button variant="outline-primary" className='mb-0 w-100 ' onClick={() => setSearchUser('')}>Pesquisar
                Outro</Button>

            </Card.Body>

          </Card></Col>
      </Row>}

    </>

  )
}

export default SearchTicket
